<template>
    <mdb-row>
        <mdb-col class="text-center">
            <mdb-row>
                <mdb-col>
                    <standard-banner></standard-banner>
                    <br />
                    <standard-banner></standard-banner>
                </mdb-col>
                <mdb-col>
                    <span class="font-weight-bold">
                        {{ errors.first('username') }} <br />
                        {{ errors.first('email') }} <br />
                        {{ errors.first('password') }} <br />
                        {{ errors.first('confirmPassword') }} <br />
                    </span>

                    <p class="font-weight-bold">
                        {{ errorList }}
                    </p>
                    <br />

                    <p class="font-weight-bold">
                        {{ successList }}
                    </p>

                </mdb-col>
                <mdb-col>
                    <standard-banner></standard-banner>
                    <br />
                    <standard-banner></standard-banner>
                </mdb-col>
            </mdb-row>

            <mdb-row>
                <mdb-col>

                    <mdb-row>
                        <mdb-col>
                            <skyscrapper-banner></skyscrapper-banner>
                        </mdb-col>
                        <mdb-col>
                            <skyscrapper-banner></skyscrapper-banner>
                        </mdb-col>
                    </mdb-row>

                </mdb-col>
                <mdb-col>
                    <mdb-card>
                        <mdb-card-body class="text-left">
                            <p class="h4 text-center py-4">Register</p>

                            <mdb-input label="Username" group icon="user" type="text" v-validate="'required|min:3|max:10|alpha_num'" v-model.trim="username" name="username" />
                            <mdb-input label="Your email" icon="envelope" group type="email" v-validate="'required|email|min:3|max:350'" name="email" v-model.trim="email" />

                            <!--v-model is need for both password fields, do not include v-dalidate-as, ref tag is used as a marker to help v-validate find password matching field-->
                            <mdb-input label="Your password" icon="lock" type="password" v-validate="'required|min:10|max:128'" name="password" v-model="password" ref="password" />
                            <mdb-input label="Confirm your password" icon="exclamation-triangle" type="password" v-validate="'required|min:10|max:128|confirmed:password'" name="confirmPassword" v-model="confirmPassword" />

                            <div class="text-center">
                                <div id="recaptcha-main" class="g-recaptcha" v-bind:data-sitekey="[recaptchav2SiteKey]" style="display: inline-block;"></div>
                                <br />
                                <a v-on:click="resendEmail()" class="font-weight-bold">Didn't receive activation email ?</a>
                                <br />
                                <mdb-btn outline="secondary" v-on:click="sendAccountRegisterApi()" type="button">Register <mdb-icon far icon="paper-plane" /></mdb-btn>
                            </div>

                        </mdb-card-body>
                    </mdb-card>

                </mdb-col>
                <mdb-col>

                    <mdb-row>
                        <mdb-col>
                            <skyscrapper-banner></skyscrapper-banner>

                        </mdb-col>
                        <mdb-col>
                            <skyscrapper-banner></skyscrapper-banner>

                        </mdb-col>
                    </mdb-row>

                </mdb-col>
            </mdb-row>

        </mdb-col>

        <button type="button" class="bottomLeftButton" id="bottomLeftButton" onClick="document.getElementById('bottomLeftBanner').remove();this.remove();">x</button>
        <div class="bottomLeftBanner" id="bottomLeftBanner"><square-banner></square-banner></div>

        <button type="button" class="bottomRightButton" id="bottomRightButton" onClick="document.getElementById('bottomRightBanner').remove();this.remove();">x</button>
        <div class="bottomRightBanner" id="bottomRightBanner"><square-banner></square-banner></div>

    </mdb-row>

</template>

<script>
    import { mdbRow, mdbCol, mdbBtn, mdbIcon, mdbInput, mdbCard, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';

    export default {
        components: { mdbRow, mdbCol, mdbBtn, mdbIcon, mdbInput, mdbCard, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText },
        data() {
            return {
                recaptchav2SiteKey: this.$store.state.recaptchav2SiteKey,
                recaptchav3SiteKey: this.$store.state.recaptchav3SiteKey,
                username: null,
                password: null,
                confirmPassword: null,
                email: null,
                apiResponse: null,
                ip: '0.0.0.0',
                errorList: null,
                successList: null
            }
        },
        created() {
            this.$nextTick(function () {
                grecaptcha.render('recaptcha-main');
            })
        },
        mounted() {
            this.axios.get(this.$store.state.ipAPI).then((response) => { this.ip = response.data.ip; }).catch((error) => { })
        },
        methods: {
            test: function () {

            },
            resendEmail: function () {

                this.$router.push('ResendEmail');
            },
            sendAccountRegisterApi: function () {

                this.$store.commit('isLoading', true);

                this.errorList = this.successList = null;
                this.$validator.validateAll().then(result => {

                    if (result === true) {

                        grecaptcha.execute(this.recaptchav3SiteKey, { action: 'Register' })
                            .then((token) => {
                                this.axios.post(this.$store.state.AccountRegisterApi,
                                    {
                                        username: this.username,
                                        email: this.email,
                                        password: this.password,
                                        confirmPassword: this.confirmPassword,
                                        referrer: this.$cookie.get('referrer'),
                                        recaptchav2Response: grecaptcha.getResponse(),
                                        recaptchav3Response: token,
                                        ip: this.ip
                                    })
                                    .then((response) => {

                                        grecaptcha.reset();
                                        for(var i in response.data){ this.successList = response.data[i]; break; }
                                        this.$store.commit('isLoading', false);
                                    })
                                    .catch((error) => {

                                        grecaptcha.reset();
                                        for(var i in error.response.data["errors"]){ this.errorList = error.response.data["errors"][i][0]; break; }
                                        this.$store.commit('isLoading', false);
                                    })
                            });
                    }

                })
            }

        }
    }
</script>